module.exports = __webpack_public_path__ + "static/media/belfast-icon.4e6a10f6.png";